import React from 'react';
import '../css/CoreExpertiseGrid.css';

const CoreExpertiseGrid = () => {
  const expertiseData = [
    {
      id: 1,
      icon: "🧯",
      themeClass: "gfi-exp-fire",
      title: "Fire & Safety Courses",
      desc: "Our institute focuses on practical learning and industry-oriented training to help students develop workplace-ready skills and professional confidence."
    },
    {
      id: 2,
      icon: "🏗️",
      themeClass: "gfi-exp-ind",
      title: "Industrial Safety Management",
      desc: "Our institute focuses on practical learning and industry-oriented training to help students develop workplace-ready skills and professional confidence."
    },
    {
      id: 3,
      icon: "📜",
      themeClass: "gfi-exp-nebosh",
      title: "NEBOSH Certifications",
      desc: "Our institute focuses on practical learning and industry-oriented training to help students develop workplace-ready skills and professional confidence."
    },
    {
      id: 4,
      icon: "🛡️",
      themeClass: "gfi-exp-iosh",
      title: "IOSH Safety Courses",
      desc: "Our institute focuses on practical learning and industry-oriented training to help students develop workplace-ready skills and professional confidence."
    },
    {
      id: 5,
      icon: "🦺",
      themeClass: "gfi-exp-hse",
      title: "HSE Programs",
      desc: "Our institute focuses on practical learning and industry-oriented training to help students develop workplace-ready skills and professional confidence."
    },
    {
      id: 6,
      icon: "🎓",
      themeClass: "gfi-exp-diploma",
      title: "Diploma & Degree Programs",
      desc: "Our institute focuses on practical learning and industry-oriented training to help students develop workplace-ready skills and professional confidence."
    },
    {
      id: 7,
      icon: "💻",
      themeClass: "gfi-exp-online",
      title: "Online & E-Learning Safety",
      desc: "Our institute focuses on practical learning and industry-oriented training to help students develop workplace-ready skills and professional confidence."
    }
  ];

  return (
    <section className="gfi-expertise-section">
      <div className="gfi-expertise-container">
        
        {/* TOP LAYOUT HEADER CONTROL */}
        <div className="gfi-expertise-header">
          <span className="gfi-expertise-tagline">OUR CORE EXPERTISE</span>
          <h2 className="gfi-expertise-main-title">Who We Are</h2>
          <p className="gfi-expertise-top-summary">
            Greenfield Industrial Fire and Safety Academy is a professional training institute focusing on practical 
            learning, professional development, and industry-oriented training.
          </p>
        </div>

        {/* 3-COLUMN RESPONSIVE EXPERTISE CARDS GRID MESH */}
        <div className="gfi-expertise-cards-grid">
          {expertiseData.map((item) => (
            <div key={item.id} className="gfi-expertise-interactive-card">
              
              {/* Dynamic Icon Canvas Wrapper with unique soft base background */}
              <div className={`gfi-expertise-icon-avatar ${item.themeClass}`}>
                <span className="gfi-exp-emoji-vector">{item.icon}</span>
              </div>

              {/* Card Structural Typography */}
              <h3 className="gfi-expertise-card-title">{item.title}</h3>
              <p className="gfi-expertise-card-desc">{item.desc}</p>
              
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default CoreExpertiseGrid;